module.exports = __webpack_public_path__ + "img/maintop.686650b.png";